import ArchiveLayout from "@/layouts/ArchiveLayout.vue";
import IntelligenceLayout from "@/layouts/IntelligenceLayout.vue";
import PlainLayout from "@/layouts/PlainLayout.vue";
import SinglePageLayout from "@/layouts/SinglePageLayout.vue";

import CvdLayout from "./CvdLayout.vue";
import DefaultLayout from "./DefaultLayout.vue";

export default {
  DefaultLayout,
  CvdLayout,
  ArchiveLayout,
  PlainLayout,
  SinglePageLayout,
  IntelligenceLayout,
};
